import { batchActions } from 'redux-batched-actions';
import { displayErrorMessage } from '@insticator/insticator-ui';
//API calls
import { asyncGetAllQuestionsAnswered,
    asyncGetTotalTopQuestionsAnswered,
    asyncGetTotalAverageInView,
    asyncGetTotalUniqueEngagedUsers,
    asyncGetTotalRevenueMetrics,
    asyncGetTotalStoryClicks,
    asyncGetTopStories
} from 'utils/api/home';

export const GET_REVENUE_METRICS_TOTAL = "GET_REVENUE_METRICS_TOTAL";
export const GET_REVENUE_METRICS_TOTAL_FETCHING = "GET_REVENUE_METRICS_TOTAL_FETCHING ";

export const GET_QUESTIONS_ANSWERED = "GET_QUESTIONS_ANSWERED";
export const QUESTIONS_ANSWERED_FETCHING = "QUESTIONS_ANSWERED_FETCHING";

export const GET_TOP_QUESTIONS = "GET_TOP_QUESTIONS";
export const TOP_QUESTIONS_FETCHING = "TOP_QUESTIONS_FETCHING";

export const GET_AVG_IN_VIEW = "GET_AVG_IN_VIEW";
export const AVG_IN_VIEW_FETCHING = "AVG_IN_VIEW_FETCHING";

export const GET_UNIQUE_USERS = "GET_UNIQUE_USERS";
export const UNIQUE_USERS_FETCHING = "UNIQUE_USERS_FETCHING";

export const GET_TOP_STORIES = "GET_TOP_STORIES";
export const TOP_STORIES_FETCHING = "TOP_STORIES_FETCHING";

export const GET_TOTAL_STORY_CLICKS = "GET_TOTAL_STORY_CLICKS";
export const TOTAL_STORY_CLICKS_FETCHING = "TOTAL_STORY_CLICKS_FETCHING";


//ONE CALL FOR ALL HOME ANALYTICS REVENUE METRICS

export const getAllRevenueMetricsTotal = ( paramString ) => dispatch => {
    dispatch(getAllRevenueMetricsTotalFetching(true));
    return asyncGetTotalRevenueMetrics(paramString)
        .then(response => {
            return dispatch(batchActions([
                getAllRevenueMetricsTotalFetching(false),
                revenueMetrics(response.data)]))
        },err => dispatch(revenueMetricsCallFail()))
};

const getAllRevenueMetricsTotalFetching = (bool) => ({type: GET_REVENUE_METRICS_TOTAL_FETCHING, bool});

const revenueMetricsCallFail = () => batchActions([
    getAllRevenueMetricsTotalFetching(false),
    displayErrorMessage('There was an issue fetching your Ad Metrics')
]);

const revenueMetrics = (data) => ({
    type: GET_REVENUE_METRICS_TOTAL,
    cpm: data.cpm,
    impression: data.impression,
    revenue: data.revenue
});



//INDIVIDUAL GET REQUESTS FOR HOME ANALYTICS

//-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//
//thunk
export const getTotalQuestionsAnswered = (startDate, endDate) => dispatch =>{
    dispatch(totalQuestionsFetching(true));
    return asyncGetAllQuestionsAnswered(startDate, endDate)
        .then(response =>{
            return dispatch(batchActions([
                totalQuestionsFetching(false),
                allQuestionsAnswered(response.data)
            ]))
        })
        .catch(err => dispatch(allQuestionsAnsweredFailed()))
};
//action creators
const totalQuestionsFetching = (status) => ({
    type: QUESTIONS_ANSWERED_FETCHING,
    status
});
const allQuestionsAnswered = data => ({
    type: GET_QUESTIONS_ANSWERED,
    data
});
const allQuestionsAnsweredFailed = () => batchActions([
    totalQuestionsFetching(false),
    displayErrorMessage('There was an issue fetching your metrics for Questions Answered')
]);
//-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//

export const getTotalTopQuestionsAnswered = ( paramString ) => dispatch =>{
    dispatch(totalTopQuestionsFetching(true));
    return asyncGetTotalTopQuestionsAnswered(paramString)
        .then(response => {
            return dispatch(batchActions([
                totalTopQuestionsFetching(false),
                topQuestionsAnswered(response.data)
            ]))
        })
        .catch(err => dispatch(topQuestionsAnsweredFailed()))
};

const topQuestionsAnswered = data => ({
    type: GET_TOP_QUESTIONS,
    data
});
//loading action from top questions

const totalTopQuestionsFetching = status => ({
    type: TOP_QUESTIONS_FETCHING,
    status
});

const topQuestionsAnsweredFailed = () => batchActions([
    totalTopQuestionsFetching(false),
    displayErrorMessage('There was an issue fetching your metrics for Top Questions Answered')
]);

//-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//

export const getTotalAverageInView = ( paramString ) => dispatch => {
    dispatch(totalAverageInViewFetching(true));
    return asyncGetTotalAverageInView(paramString)
        .then(response => {
            return dispatch(batchActions([
                totalAverageInViewFetching(false),
                averageInView(response.data)]))
        })
        .catch(err => dispatch(averageInViewFail()) )
};

const averageInView = data => ({
    type: GET_AVG_IN_VIEW,
    data
});

const averageInViewFail = () => batchActions([
    totalAverageInViewFetching(false),
    displayErrorMessage('There was an issue fetching your metrics for Average In View %')
]);

export const totalAverageInViewFetching = status => ({
    type: AVG_IN_VIEW_FETCHING,
    status
});

//-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//

export const getTotalUniqueEngagedUsers = ( paramString ) => dispatch => {
    dispatch(totalUniqueUsersFetching(true));
    return asyncGetTotalUniqueEngagedUsers(paramString)
        .then(response => {
            return dispatch(batchActions([totalUniqueUsersFetching(false),
                uniqueEngagedUsers(response.data)]))
        })
        .catch(err => dispatch(uniqueEngagedUsersFail()))
};

const  totalUniqueUsersFetching = status => ({
    type: UNIQUE_USERS_FETCHING,
    status
});

const uniqueEngagedUsers = data => ({
    type: GET_UNIQUE_USERS,
    data
});

const uniqueEngagedUsersFail = () => batchActions([
    totalUniqueUsersFetching(false),
    displayErrorMessage('There was an issue fetching your metrics for Unique Engaged Users')
]);


//-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//

export const getTopStories = (paramstring) => dispatch => {
    dispatch(topStoriesFetching(true));
    asyncGetTopStories(paramstring)
        .then(response => {
            return dispatch(batchActions([
                topStories(response.data),
                topStoriesFetching(false)
            ]))
        })
        .catch(err=> dispatch(topStoriesFetching(false))
        )
};
export const topStories = data => ({
    type: GET_TOP_STORIES,
    data
});
export const topStoriesFetching = () => ({type: TOP_STORIES_FETCHING});

//-=-=---=--=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-==-=-=//

export const getTopStoryClicks = (paramString) => dispatch => {
    dispatch(topStoryClicksFetching(true));
    return asyncGetTotalStoryClicks(paramString)
        .then(response => {
            return dispatch(batchActions([
                topStoryClicks(response.data),
                topStoryClicksFetching(false)
            ]))
        })
        .catch(err => dispatch(topStoryClicksFetching(false)))
};
const topStoryClicksFetching = (status) => ({
    type: TOTAL_STORY_CLICKS_FETCHING,
    status
});
const topStoryClicks = (data) => ({
    type: GET_TOTAL_STORY_CLICKS,
    data
});

